module.exports = __webpack_public_path__ + "img/example12.4cef401d.jpg";